module.exports = __webpack_public_path__ + "img/air2.51870d19.jpg";